import { render, staticRenderFns } from "./ProgressRing.vue?vue&type=template&id=305e5812&scoped=true"
import script from "./ProgressRing.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressRing.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProgressRing.vue?vue&type=style&index=0&id=305e5812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e5812",
  null
  
)

export default component.exports